import React from 'react';
import config from './config';
import {Amplify} from 'aws-amplify';
import {createRoot} from "react-dom/client";
import {createBrowserRouter, RouterProvider} from "react-router-dom";
import App from './App';



//  variable declarations ------------------------------------------------------------------------------------------

const container = document.getElementById("root");
const root = createRoot(container);



//  app configuration ----------------------------------------------------------------------------------------------

Amplify.configure({
  Auth: {
    mandatorySignIn: true,
    region: config.cognito.REGION,
    userPoolId: config.cognito.USER_POOL_ID,
    identityPoolId: config.cognito.IDENTITY_POOL_ID,
    userPoolWebClientId: config.cognito.APP_CLIENT_ID
  },
  Storage: {
    region: config.s3.REGION,
    bucket: config.s3.BUCKET,
    identityPoolId: config.cognito.IDENTITY_POOL_ID
  },
  API: {
    endpoints: [
      {
        name: "admin",
        endpoint: config.apiGateway_admin.URL,
        region: config.apiGateway_admin.REGION
      },
      {
        name: "admin-activities",
        endpoint: config.apiGateway_admin_activities.URL,
        region: config.apiGateway_admin_activities.REGION
      },
      {
        name: "admin-providers",
        endpoint: config.apiGateway_admin_providers.URL,
        region: config.apiGateway_admin_providers.REGION
      },
      {
        name: "admin-domains",
        endpoint: config.apiGateway_admin_domains.URL,
        region: config.apiGateway_admin_domains.REGION
      }
    ]
  }
});



// RENDER APP ======================================================================================================

// After Amplify config, create router:
const router = createBrowserRouter([
  {
    path: '/*',
    element: <App/>
  }
], {
  future: {
    v7_startTransition: true,
  }
});

// Then render:
root.render(
  <React.StrictMode>
    <RouterProvider router={router}/>
  </React.StrictMode>
);
